import './Programacion.scss'

const Programacion: React.FC = () => {
  return (
    <div className="page-wrapper programacion-wrapper">
      <main className="page-main">
        <div className="container">
          <section className="hero-section faq-hero">
            <div className="iframe-container">
              <iframe
                src="https://www.tcsahora.com/epg-tcsgo/"
                title="Programación"
                className="programacion-iframe"
              />
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};


export default Programacion;
